import {useEffect, useMemo} from "react";
import {useHistory} from "react-router";

import {RouteChangeValidator} from "@pg-mono/data-fetcher";

const REELS_QUERY_PARAM = "reels";

export const useReelUrlSync = () => {
    const history = useHistory();

    const getSearchQuery = () => {
        return new URLSearchParams(typeof window === "undefined" ? history.location.search : window.location.search);
    };

    const createReelUrl = (reelId?: number) => {
        if (typeof window === "undefined") {
            return "";
        }

        const newQuery = new URLSearchParams(window.location.search);

        if (reelId) {
            newQuery.set(REELS_QUERY_PARAM, reelId.toString());
        } else {
            newQuery.delete(REELS_QUERY_PARAM);
        }

        return `${window.location.pathname}?${newQuery}`;
    };

    const createReelFullUrl = (reelId?: number) => {
        const locationOrigin = typeof window !== "undefined" ? window.location.origin : "";
        return `${locationOrigin}${createReelUrl(reelId)}`;
    };

    const syncReelUrl = (reelId?: number) => {
        history.push(createReelUrl(reelId));
    };

    const hasUrlWithReelId = useMemo(() => {
        const query = getSearchQuery();
        return query.has(REELS_QUERY_PARAM);
    }, [history.location]);

    const getReelIdFromUrl = () => {
        const query = getSearchQuery();
        const reelId = query.get(REELS_QUERY_PARAM);
        return reelId ? parseInt(reelId, 10) : null;
    };

    useEffect(() => {
        RouteChangeValidator.registerIgnoredParam(REELS_QUERY_PARAM);
    }, []);

    return {
        createReelFullUrl,
        syncReelUrl,
        hasUrlWithReelId,
        getReelIdFromUrl
    };
};
import {useEffect, useMemo} from "react";
import {useHistory} from "react-router";

import {RouteChangeValidator} from "@pg-mono/data-fetcher";

const REELS_QUERY_PARAM = "reels";

export const useReelUrlSync = () => {
    const history = useHistory();

    const getSearchQuery = () => {
        return new URLSearchParams(typeof window === "undefined" ? history.location.search : window.location.search);
    };

    const createReelUrl = (reelId?: number) => {
        if (typeof window === "undefined") {
            return "";
        }

        const newQuery = new URLSearchParams(window.location.search);

        if (reelId) {
            newQuery.set(REELS_QUERY_PARAM, reelId.toString());
        } else {
            newQuery.delete(REELS_QUERY_PARAM);
        }

        return `${window.location.pathname}?${newQuery}`;
    };

    const createReelFullUrl = (reelId?: number) => {
        const locationOrigin = typeof window !== "undefined" ? window.location.origin : "";
        return `${locationOrigin}${createReelUrl(reelId)}`;
    };

    const syncReelUrl = (reelId?: number) => {
        history.push(createReelUrl(reelId));
    };

    const hasUrlWithReelId = useMemo(() => {
        const query = getSearchQuery();
        return query.has(REELS_QUERY_PARAM);
    }, [history.location]);

    const getReelIdFromUrl = () => {
        const query = getSearchQuery();
        const reelId = query.get(REELS_QUERY_PARAM);
        return reelId ? parseInt(reelId, 10) : null;
    };

    useEffect(() => {
        RouteChangeValidator.registerIgnoredParam(REELS_QUERY_PARAM);
    }, []);

    return {
        createReelFullUrl,
        syncReelUrl,
        hasUrlWithReelId,
        getReelIdFromUrl
    };
};
